import { useState } from "react";
import { Container } from "react-bootstrap";

export default function Banner({heading, description}) {
  const [selectedCategory, setSelectedCategory] = useState("Cardiology");

  const handleSelect = (eventKey) => {
    setSelectedCategory(eventKey);
  };

  return (
    <div className="search-article-container banner">
      <Container>
        <div className="search-header text-center">
          <h1>{heading}</h1>
          <p className="mb-0">
            {description}
          </p>
        </div>
      </Container>
    </div>
  );
};